// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyTwoToneSvg from "@ant-design/icons-svg/es/asn/CopyTwoTone";
import AntdIcon from '../components/AntdIcon';

var CopyTwoTone = function CopyTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyTwoToneSvg
  }));
};

CopyTwoTone.displayName = 'CopyTwoTone';
export default React.forwardRef(CopyTwoTone);